<template>
    <v-container class="fill-height" style="display: block; padding: 0;" fluid>

            <div class="screenshots-top">
                <div class="close-container" @click="$emit('close')">
                    <v-icon large>mdi-arrow-right-bold-circle</v-icon>
                </div>
                <div class="screenshots-title-container">
                    <span>Application Screenshots</span>
                </div>
            </div>

            <v-divider />

            <template v-for="(screenshot, index) in $store.state.screenshots" v-if="$store.state.screenshots.length">
                <div class="screenshot-container">
                    <div class="image-container">
                        <img :src="screenshot.data" />
                    </div>
                    <div class="info-container">
                        <span class="image-title" v-text="screenshot.area" />
                        <span class="image-time" v-text="screenshot.displayTime" />
                        <span class="image-size" v-text="getReadableFileSize(screenshot.size)" />
                        <div class="image-buttons-container">
                            <v-btn x-large icon @click="downloadScreenshot(screenshot)">
                                <v-icon>mdi-cloud-download</v-icon>
                            </v-btn>
                            <v-btn x-large icon @click="deleteScreenshot">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
                <v-divider />
            </template>

            <div class="no-screenshots-container" v-if="!$store.state.screenshots.length">
                <v-icon class="no-screenshots-icon">mdi-image-off</v-icon>
                <span class="no-screenshots-text">No screenshots. Press (ctrl + shift + enter) to take an application screenshot.</span>
            </div>
            

    </v-container>
</template>



<script>
export default {
    name: 'Screenshots',
    props: [],
    components: {

    },
    data: () => ({
    }),

    computed: {

    },

    methods: {
        getReadableFileSize: function(size) {
            return TELSA.readableFileSize(size);
        },

        deleteScreenshot: function(screenshot) {
            this.$store.commit('deleteScreenshot', screenshot);
        },

        downloadScreenshot: function(screenshot) {
            let dlink = document.createElement('a');
            dlink.setAttribute("id", "screenshot-download-file-link-hidden");
            dlink.href = screenshot.data;
            dlink.download = screenshot.name;
            dlink.click();
            dlink.remove();
        }
    },

    watch: {
    },

    mounted() {
    }

};
</script>

<style scoped>

    .screenshots-top {
        position: relative;
        height: 65px;
    }
    .screenshots-top .close-container {
        display: inline-block;
        height: 100%;
        width: 80px;
        cursor: pointer;
        border-right: rgba(255, 255, 255, 0.12) solid 1px;
        float: left;
        text-align: center;
        padding-top: 14px;
    }
    .screenshots-top .close-container:hover {
        background-color: rgb(85,85,85);
    }
    
    .screenshots-top .screenshots-title-container {
        display: inline-block;
        margin: 8px 0px 0px 12px;
        float: left;
    }
    .screenshots-top .screenshots-title-container span {
        display: block;
        font-size: 30px;
    }
    @media(max-width: 600px) {
        .screenshots-top .screenshots-title-container span {
            font-size: 24px;
            margin: 6px 0px 0px 12px;
        }
    }


    .no-screenshots-container {
        width: 100%;
        height: 200px;
        margin-top: calc(((100vh - 265px) / 3));
        text-align: center;
    }
    .no-screenshots-container .no-screenshots-icon {
        color: rgba(0, 0, 0, 0.6);
        font-size: 130px;

    }
    .no-screenshots-container .no-screenshots-text {
        display: block;
        font-size: 18px;
        margin: 0 60px;
        color: rgba(0, 0, 0, 0.6);
        font-weight: bold;
    }

    .screenshot-container {
        width: calc(100% - 2em);
        height: 140px;
        margin: 15px;
        position: relative;
    }
    .screenshot-container:hover {
        /* background-color: rgb(85,85,85); */
    }

    .image-container {
        display: inline-block;
        width: 250px;
        height: 100%;
        margin-right: 10px;
        position: relative;
        text-align: center;

        float: left;
    }
    .image-container img {
        position: relative;
        max-width: 248px;
        max-height: 100%;
        border: rgba(255, 255, 255, 0.12) solid 1px;
    }

    .info-container {
        display: inline-block;
        width: calc(100% - 260px);
        height: 100%;

        float: left;
    }
    .info-container .image-title {
        display: block;
        font-size: 22px;
    }
    .info-container .image-time {
        display: block;
        font-size: 14px;
    }
    .info-container .image-size {
        display: block;
        font-size: 14px;
    }
 
</style>
